export default {
  title: 'Container Management',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Container type, ISO code, description',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addContainer: 'Add Container',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enable: 'Enable',
    disable: 'Disable',
    ediCodeSetting: 'EDI Code Setting',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    containerType: 'Container Type',
    isoCode: 'ISO Code',
    description: 'Description',
    ediCode: 'EDI Code',
    codeCount: '{count} codes',
    notSet: 'Not Set',
    status: 'Status',
    operation: 'Operation'
  },

  // Platform association modal
  modal: {
    title: 'Add Container Type',
    confirmText: 'Confirm Add',
    searchPlaceholder: 'Search container type, ISO code, description',
    selected: 'Selected {count} container types',
    tableTitleContainerType: 'Container Type',
    tableTitleIsoCode: 'ISO Code',
    tableTitleDescription: 'Description'
  },

  // Confirmation dialogs
  confirm: {
    toggleStatus: 'Are you sure to {action} this container?'
  },

  // EDI setting modal
  ediModal: {
    title: 'EDI Code Setting',
    ediCodeList: 'EDI Code List',
    platform: 'Platform',
    platformRequired: 'Please select platform',
    platformPlaceholder: 'Select platform',
    ediCode: 'EDI Code',
    ediCodeRequired: 'Please enter EDI code',
    ediCodePlaceholder: 'Please enter EDI code',
    addEdiCode: 'Add EDI Code',
    deleteEdiCode: 'Delete',
    duplicateWarning: 'Duplicate platform',
    optional: '(Optional)',
    carrier: 'Carrier',
    carrierPlaceholder: 'Select carrier',
    duplicateRowsError: 'Duplicate platform in row(s) {rows}',
    duplicateRowsSaveError: 'Duplicate platform in row(s) {rows}, please fix before saving'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select container types to enable',
    selectToDisable: 'Please select container types to disable',
    selectToAssociate: 'Please select container types to add',
    loadError: 'Data loading failed',
    platformLoadError: 'Platform data loading failed',
    associateError: 'Add failed',
    associateSuccess: 'Added {count} container types',
    statusToggleError: 'Operation failed',
    statusToggleSuccess: 'Status toggle successful',
    batchEnableError: 'Batch operation failed',
    batchEnableSuccess: 'Enabled {count} container types',
    batchDisableError: 'Batch operation failed',
    batchDisableSuccess: 'Disabled {count} container types',
    ediCodeSaveSuccess: 'EDI code setting successful',
    ediCodeSaveError: 'EDI code saving failed'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  }
}